import ApolloClient from "apollo-client";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { WebSocketLink } from 'apollo-link-ws';
import { onError } from "apollo-link-error";
import { setContext } from 'apollo-link-context';
import { ApolloLink, split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';
import { Auth } from 'aws-amplify';
import defaults from './defaults';
import resolvers from './resolvers';

const refreshToken = async closeConnection => {
  try {
    console.log('Refresh auth token');
    const cognitoUser = await Auth.currentAuthenticatedUser()
    const currentSession = await Auth.currentSession()
    cognitoUser.refreshSession(currentSession.getRefreshToken(), (err, session) => {
      if (closeConnection) {
        console.log('close ws conn and reconnect');
        wsLink.subscriptionClient.close(false, false);
      }
    });
  } catch (e) {
    console.log("Unable to refresh Token", e)
  }
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );

  if (networkError) console.log(`[Network error]:`, networkError);
});

const cache = new InMemoryCache({
  addTypename: true,
});

const authLink = setContext(async (_, { headers }) => {
  const session = await Auth.currentSession();
  const token = session.idToken.jwtToken;
  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`
    }
  }
});

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_HGE_ENDPOINT,
});

const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_HGE_ENDPOINT.replace('https', 'wss'),
  options: {
    lazy: true,
    reconnect: true,
    connectionParams: async () => {
      try {
        console.log('connectionParams');
        await refreshToken(false);
        const session = await Auth.currentSession();
        const token = session.idToken.jwtToken;
        return ({
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      } catch (e) {
        console.log('connectionParams error');
        console.log(e);
      }
    }
  }
});

const timeoutInMinutes = 50
setInterval(() => {
  refreshToken(true);
}, timeoutInMinutes * 60 * 1000);


const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
);

const client = new ApolloClient({
  cache,
  resolvers,
  link: ApolloLink.from([errorLink, authLink, link]),
  defaultOptions: {
    query: {
      fetchPolicy: 'cache-first'
    },
  }
});

cache.writeData({
  data: defaults
});

export default client;
